<!--
    班级管理-编辑-老师选择
    功能：添加负责老师
-->
<script>
/**
   * @overview 老师选择
   *
   * @author neko
   */

import { form } from '@/mixins';
import defaultMan from "@/assets/images/staff_man.png";
import defaultWomen from "@/assets/images/staff_women.png";

export default {
  name: 'TeacherSelect',

  mixins: [form],

  props: {
    studentSelected: {
      type: Array,
      default: () => [],
    },
    reloadTeacher: {
      type: Boolean,
      default: false,
    },
    openPopup: {
      type: Boolean,
      default: false,
    },
    centerDialogVisible: {
      type: Boolean,
      default: false,
    },
    importTeachers: {
      type: Boolean,
      default: false,
    },
    departmentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      moveErrorMan: 'this.src="' + defaultMan + '"',
      moveErrorWomen: 'this.src="' + defaultWomen + '"',
      list: {},
      teacherCol: [
        { prop: 'name', label: '老师名称' },
        { prop: 'mobile', label: '手机号' }
      ],
      oldPage: {
        page: 1,
        per_page: 10,
        'order[id]': 'desc'
      },
      searchObj: {
        page: 1,
        per_page: 10,
        'order[id]': 'desc'
      },
      inputValue: '',
      selectValue: '',
      currSelectList: [],
      // 控制页面加载状态
      loading: false,
      selectData: [],
    };
  },

  computed: {
    selectWidth() {
      const maxLength = Math.max(
        ...this.searchList.map(({ label }) => label.length),
      );

      return `${maxLength + 4}em`;
    },

    searchList() {
      return [
        { prop: 'name', label: '老师名称' },
        { prop: 'mobile', label: '手机号' }
      ];
    },
  },

  watch: {
    departmentId() {
      this.getTeacherList();
    },
    importTeachers(val) {
      if (val) {
        this.getTeacherList();
      }
    },
    list() {
      this.currSelectList = [];
    },
    openPopup(val) {
      if (val) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    reloadTeacher(val) {
      if (val) {
        this.getTeacherList();
      }
    },
    centerDialogVisible(val) {
      if (!val) {
        this.getTeacherList();
      }
    },
  },

  created() {
    this.getTeacherList();
  },

  methods: {
    getTeacherList(page) {
      // this.toggleSelection()
      this.loading = true;
      this.searchObj = {
        page: page ? 1 : this.searchObj.page,
        per_page: this.searchObj.per_page,
        'order[id]': this.searchObj['order[id]']
      };

      if (this.selectValue) {
        this.searchObj[`like[${this.selectValue}]`] = this.inputValue;
      }
      console.log(this.searchObj);
      const query = Object.keys(this.searchObj)
        .map(key => `${key}=${this.searchObj[key]}`)
        .join('&');

      this.$http
        .get(`/api/staff?role_code=TE&${query}`)
        .then((data) => {
          this.list = data;
          setTimeout(() => {
            this.toggleSelection();
          }, 0);
        })
        .catch(() => {
          this.$message.error('数据请求发生错误');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSizeChange(per_page) {
      this.oldPage = this.searchObj;
      this.searchObj = {
        ...this.searchObj,
        page: 1,
        per_page,
      };

      this.getTeacherList();
    },

    onCurrentChange(page) {
      this.oldPage = this.searchObj;
      this.searchObj = {
        ...this.searchObj,
        page,
      };

      this.getTeacherList();
    },

    toggleSelection() {
      const selectedList = this.teacherSelected;

      if (selectedList && selectedList.length > 0) {
        const selectedIndex = [];
        for (let i = 0; i < selectedList.length; i++) {
          for (let j = 0; j < this.list.data.length; j++) {
            if (this.list.data[j].id === selectedList[i].id) {
              selectedIndex.push(j);
            }
          }
        }
        selectedIndex.forEach((index) => {
          this.$refs.multipleTable.toggleRowSelection(this.list.data[index * 1], true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    getSelectList(val) {
      this.$emit('teacherSelected', val);
      this.currSelectList = val;
    },

    addTeacher(val) {
      val.forEach((item) => {
        const teacher = this.teacherSelected.find(
          valItem => item.id === valItem.id,
        );

        if (!teacher) {
          this.teacherSelected.push(item);
        }
      });

      this.sendTeacherList();
    },

    delTeacher(val) {
      this.currSelectList.forEach((item) => {
        const teacher = val.find(selItem => item.id === selItem.id);

        if (!teacher) {
          const delIndex = this.teacherSelected.findIndex(
            totalItem => item.id === totalItem.id,
          );

          this.teacherSelected.splice(delIndex, 1);
        }
      });

      this.sendTeacherList();
    },

    sendTeacherList() {
      this.$emit('teacherList', this.teacherSelected);
    },
  },
};
</script>

<template>
  <div
    v-loading="loading"
    class="teacher-select">
    <div class="teacher-select__search">
      <el-input
        v-model="inputValue"
        class="teacher-select__input"
        placeholder="请输入关键字进行搜索"
        size="small"
        @keyup.enter.native="getTeacherList('changePage')"
      >
        <el-select
          slot="prepend"
          v-model="selectValue"
          :style="{ width: selectWidth }"
          placeholder="请选择"
        >
          <el-option
            v-for="column in searchList"
            :key="column.prop"
            :label="column.label"
            :value="column.prop"
          />
        </el-select>
      </el-input>

      <el-button
        slot="append"
        icon="el-icon-search"
        size="small"
        class="teacher-select__button"
        @click="getTeacherList('changePage')"
      />
    </div>

    <div style="clear:both;"/>

    <!-- @select="getSelectList" -->
    <el-table
      ref="multipleTable"
      :data="list.items"
      highlight-current-row
      @current-change="getSelectList">
      <el-table-column
        width="80px"
        label="头像">
        <template slot-scope="scope">
          <img
            class="head_url"
            :src="scope.row.headimgurl ? scope.row.headimgurl : ''"
            :onerror="scope.row.gender === 1 ? moveErrorMan : moveErrorWomen"
            alt="">
        </template>
      </el-table-column>
      <el-table-column
        v-for="col in teacherCol"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
      />
    </el-table>

    <footer class="teacher-select__footer">
      <el-pagination
        v-if="list.meta && list.meta.total > 10"
        :current-page="list.meta.current_page"
        :page-sizes="[10, 20, 50, 100, 500]"
        :page-size="10"
        :total="list.meta.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
      />
    </footer>
  </div>
</template>

<style lang="scss" scoped>
  .teacher-select {
    .teacher-select__search {
      width: 370px;
      float: right;
    }
    .teacher-select__input {
      width: 300px;
    }
    .teacher-select__selected {
      max-height: 150px;
      overflow: auto;
      margin: 20px 0;
    }
    .teacher-select__selected {
      .el-tag {
        margin: 5px 5px 0 0;
      }
    }
    .teacher-select__footer {
      padding: 2em 0 1em;
      margin-top: auto;
    }
    .head_url {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ClassManage/TeacherSelect.vue